import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useTheme } from '../../ThemeContext';

export const billingTabOptions = [
  { label: 'Usage', value: 'usage' },
  { label: 'Plans & Limits', value: 'plans' },
  { label: 'Billing Settings', value: 'settings' },
];

const BillingTabs = ({ value, onChange }) => {
  const { currentTheme } = useTheme();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Tabs
        value={value}
        onChange={onChange}
        textColor="inherit"
        TabIndicatorProps={{ sx: { backgroundColor: '#FF5C5C', height: 3 } }}
        sx={{
          minHeight: 48,
          '& .MuiTab-root': {
            minHeight: 48,
            fontWeight: 500,
            fontSize: '1rem',
            color: currentTheme.text.primary,
            textTransform: 'none'
          },
          '& .Mui-selected': {
            color: '#FF5C5C',
          },
        }}
      >
        {billingTabOptions.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
    </Box>
  );
};

export default BillingTabs; 